import { gps } from "exifr/dist/lite.esm.mjs"

import Hook from "../../utils/hook"

export const SitePage = Hook(`SitePage`, {
  refs: [`map`],
  targets: [`mobileMapToggle`],
  values: { mobileMapActive: Boolean },
  actions: [
    {
      name: `showMobileMap`,
      target: `mobileMapToggle`,
      type: `click`,
    },
  ],

  enterMapFullscreenOnLoad: false,

  mapRefMounted(mapRef) {
    mapRef.addReceiveHandler(this.mapReceive.bind(this))
  },

  showMobileMapAction() {
    this.mobileMapActiveValue = true

    if (this.mapRef && this.mapRef.el.dataset.naturkartanInited)
      this.enterMapFullscreen()
    else this.enterMapFullscreenOnLoad = true
  },

  mapReceive(message) {
    switch (message.method) {
      case `loaded`: {
        if (this.enterMapFullscreenOnLoad) {
          this.enterMapFullscreenOnLoad = false
          this.enterMapFullscreen()
        }
        break
      }

      case `setFullscreen`: {
        this.mobileMapActiveValue = message.active
        break
      }
    }
  },

  enterMapFullscreen() {
    if (this.mapRef) this.mapRef.setFullscreen(true)
  },
})

// reads GPS coordinates from the EXIF data of selected/dropped report photos and
// sends the first valid pair to the LiveView (until the LiveView has a position)
export const SitePageReportImagesUpload = Hook(`SitePageReportImagesUpload`, {
  values: { eventName: String, hasPosition: Boolean },
  actions: [
    // `input` (not `change`): LiveView handles `input` on `window` and clears
    // multiple file inputs there, so the files are only readable before it
    // bubbles up to `window`, i.e. here on the hook root element
    {
      name: `filesInput`,
      type: `input`,
    },
    {
      name: `filesDrop`,
      type: `drop`,
    },
  ],

  mounted() {
    this.finding = false
  },

  filesInputAction(e) {
    if (e.target?.type === `file`) this.findPosition(e.target.files)
  },

  filesDropAction(e) {
    this.findPosition(e.dataTransfer?.files)
  },

  async findPosition(files) {
    if (this.hasPositionValue || this.finding || !files?.length) return
    this.finding = true

    // copy, as the file input may be reset while files are being read
    const list = [...files]

    try {
      for (const file of list) {
        const position = await this.readPosition(file)
        if (position) {
          this.pushEvent(this.eventNameValue, position)
          return
        }
      }
    } finally {
      this.finding = false
    }
  },

  async readPosition(file) {
    try {
      const { latitude, longitude } = (await gps(file)) || {}
      const valid =
        Number.isFinite(latitude) &&
        Number.isFinite(longitude) &&
        Math.abs(latitude) <= 90 &&
        Math.abs(longitude) <= 180 &&
        !(latitude === 0 && longitude === 0)

      return valid ? { lat: latitude, lng: longitude } : null
    } catch {
      return null // not an image with readable EXIF data
    }
  },
})
